import { isEmptyObject } from "../../../utils/tests";
import { PlayerStatisticsQuery  } from '../types';

/**
 * typeguard for PpPlayerStatisticsQuery
 * @param PpPlayerStatisticsQuery object passed to transformer
 */
export const isValidPpPlayerStatisticsQuery = (obj: PlayerStatisticsQuery): boolean => Boolean(obj?.data?.getPlayerPagesStats && !isEmptyObject(obj.data.getPlayerPagesStats));